import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { SecurityBadge } from "../SecurityBadge";
import { isExistingMember } from "../helpers";
import type { EmailVerificationStatus } from "../types";

const LOCALE_ROOT = "paywall_checkout.form.email_verification_states.otp_state";

interface FooterSectionProps {
  isResending?: boolean;
  isSubmitting?: boolean;
  onShowPasswordForm: () => void;
  status: EmailVerificationStatus | null;
}

export const FooterSection = ({
  status,
  isSubmitting = false,
  isResending = false,
  onShowPasswordForm,
}: FooterSectionProps) => (
  <div className="flex items-center justify-between">
    {isExistingMember(status) && (
      <Button
        type="button"
        variant="link"
        onClick={onShowPasswordForm}
        disabled={isSubmitting || isResending}
        className="!px-0 underline"
      >
        <Typography.LabelSm weight="normal">
          {t([LOCALE_ROOT, "sign_in_with_password"])}
        </Typography.LabelSm>
      </Button>
    )}

    <SecurityBadge />
  </div>
);
